// jobBoardPrefs — persist the candidate's job-board filter/sort settings across
// sessions (#39, Phase 1). Filters are merged onto EMPTY_JOB_FILTERS on load so
// adding a new filter field later never breaks a stored value.
import { EMPTY_JOB_FILTERS, type JobFilters, type JobSort } from '@/lib/jobMatching';

const KEY = 'nexilink.jobBoard.prefs.v1';

export interface JobBoardPrefs {
    filters: JobFilters;
    sort: JobSort;
}

const DEFAULT_PREFS: JobBoardPrefs = { filters: EMPTY_JOB_FILTERS, sort: 'recent' };

export function loadJobBoardPrefs(): JobBoardPrefs {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return DEFAULT_PREFS;
        const parsed = JSON.parse(raw) as Partial<JobBoardPrefs>;
        return {
            filters: { ...EMPTY_JOB_FILTERS, ...(parsed.filters ?? {}) },
            sort: parsed.sort === 'deadline' ? 'deadline' : 'recent',
        };
    } catch {
        return DEFAULT_PREFS;
    }
}

export function saveJobBoardPrefs(prefs: JobBoardPrefs): void {
    try {
        localStorage.setItem(KEY, JSON.stringify(prefs));
    } catch {
        /* storage unavailable — non-fatal, filters just won't persist */
    }
}
